import './element-ui';
import dayjs from "dayjs";
import Vue from 'vue'
// import directive from './loading/directive';
// import service from './loading/index';
import drag from './drag'
import wfUi from './wf-components-ui'
import api from '@/services/api/upload/upload'
import axios from 'axios'
// Vue.use(directive);
Vue.use(wfUi)
Vue.directive('drag', drag)
// Vue.prototype.$loading = service;
let typeVideo = ['mp4', 'mpeg', 'mpg', 'dat', 'avi', 'mov', 'asf', 'wmv', 'navi', '3gp', 'mkv', 'flv', 'f4v', 'rmvb', 'webm', 'hddvd', 'qsv']
export function fileDown(url, name, fn = () => { }) {
  let instance = axios.create({})
  const CancelToken = axios.CancelToken;
  let source = CancelToken.source()
  let count = 0
  let httpDefaultOpts = {
    baseURL: process.env.NODE_ENV === 'development' ? 'airworthiness_certified' : 'https://eh-workflow.oss-cn-shenzhen.aliyuncs.com',
    method: 'get',
    cache: false,
    url: url.replace('https://eh-workflow.oss-cn-shenzhen.aliyuncs.com', ''),
    timeout: 30000,
    responseType: 'blob',
    headers: { 'Content-Type': 'multipart/form-data', 'Accept': '*/*' },
    cancelToken: source.token,
    onDownloadProgress: a => {
      count = parseInt(100 * (a.loaded / a.total))
      fn(count > 100 ? 99 : count)
    },
  }
  return instance(httpDefaultOpts).then(res => {
    exportData(res.data, name)
    fn(100)
  }).catch(err => {
    source.cancel()
    count = 0
    fn(count)
  })
}

function exportData(data, fileName = '导出表.xls') {
  const content = data
  const blob = new Blob([content])
  if ('download' in document.createElement('a')) {
    // 非IE下载
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  } else {
    // IE10+下载
    navigator.msSaveBlob(blob, fileName)
  }
}

function downloadUrl(params, fn) {
  let httpDefaultOpts = {
    baseURL: process.env.NODE_ENV === 'development' ? 'airworthiness_certified' : 'https://eh-workflow.oss-cn-shenzhen.aliyuncs.com',
    method: 'get',
    cache: false,
    url: params.url.replace('https://eh-workflow.oss-cn-shenzhen.aliyuncs.com', ''),
    timeout: 30000,
    responseType: 'blob',
    headers: { 'Content-Type': 'multipart/form-data', 'Accept': '*/*' }
  }
  // console.log(httpDefaultOpts)
  return axios(httpDefaultOpts).then(res => {
    console.log(res)
    const blob = res.data
    fn ? fn(URL.createObjectURL(blob)) : ''
    window.open(URL.createObjectURL(blob))
  })
}
/**
 *
 * @param {String} type
 * @returns {Boolean}
 */
const canPreview = (type)  => {
  return type && ['pdf', 'png', 'jpg', 'docx', 'folder', 'video', 'mp4', 'avi', 'flv', 'wav', 'mov', 'mpeg', 'dat', 'mpg'].includes(type.toLowerCase())
}
const getOssUrl = (name, resove) => {
  return api.getFileUrl({ oss_attachment_name: name }).then(res => {
    resove ? resove(res) : ''
  })
}

const opendImgUrl = (type, url) => {
  // console.log('type', type)
  let types = ['jpg', 'png', 'gif', 'jpeg', 'tiff', 'psd', 'raw', 'eps', 'svg', 'bmp']
  if (types.indexOf(type ? type.toLowerCase() : '') > -1) {
    Vue.prototype.$viewerApi({
      images: [url],
    })
  } else if (typeVideo.indexOf(type ? type.toLowerCase() : '') > -1) {
    Vue.prototype.$showVideo({ url })
  } else if (type === 'pdf') {
    downloadUrl({ url })
  } else {
    window.open('https://quick.ehang.com/filePreview/index.html?src=' + encodeURIComponent(url))
    // window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url))
  }
}
// 是否能预览
const isCanPreview = (type) => {
  let types = ['jpg', 'png', 'gif', 'jpeg', 'tiff', 'psd', 'raw', 'eps', 'svg', 'bmp', 'pdf', 'docx', ...typeVideo]
  return types.indexOf(type ? type.toLowerCase() : '') > -1
}
/**
 *
 * @param { String } url // 图片url
 * @param { Funtion } fn // 回调函数
 */
const getBase64Img = (url,fn) => {
  if (url) {
    var that = this;
    var image = new Image();
    image.src = url + "?" + Math.random();
    image.crossOrigin = 'anonymous';
    image.onload = function() {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, image.width, image.height);
        var ext = image.src.substring(image.src.lastIndexOf(".") + 1).toLowerCase();
        var dataURL = canvas.toDataURL("image/" + ext);
        if (fn) {
          fn(dataURL)
        }
        return dataURL;
    }
  }
}
/**
 * 链式判断属性是否为空
 * @param {Object} obj
 * @param {String} rest for 'a.b.c.d'
 * @returns {Boolean}
 */
const optionalChaining = (obj, rest) => {
  let tmp = obj;
  let _rest = rest.split('.')
  for (let key in _rest) {
    let name = _rest[key];
    tmp = tmp?.[name];
  }
  return tmp
}

/**
 * 获取文件类型对应的图标
 * @param {String} suffxe
 * @returns {String} 对应类型图片链接
 */
const getFileTypeUrl = (suffxe) => {
  if(!suffxe) return ''
  let suf = suffxe.toString().toLowerCase()
  let fileType = {
    doc: ['doc', 'docx', 'text'],
    pdf: ['pdf'],
    pic: ['jpg', 'png', 'jpeg', 'bmp', 'svg'],
    ppt: ['ppt', 'pptx'],
    execl: ['xlsx', 'xls'],
    video: ['video', 'mp4', 'avi', 'flv', 'wav', 'mov', 'mpeg', 'dat', 'mpg'],
    rar: ['zip', 'rar']
  }
  let fl = false
  let url = ''
  for (let key in fileType) {
    if (fileType[key].indexOf(suf) > -1) {
      fl = true
      url = 'image/file/' + key + '.png'
    }
  }
  if (!fl) {
    url = 'image/file/normal.png'
  }
  return url
}
// uuid
export const uuid = () => {
  var d = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
    }
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;    // d是随机种子
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
}
/**
 * 获取文件大小
 * @param {Number} size
 * @returns {String} 25KB | 25MB | 25G
 */
const getfilesize = (size) => {
  if (!size) return "";
  var num = 1024.00; //byte
  if (size < num)
    return size + "B";
  if (size < Math.pow(num, 2))
    return (size / num).toFixed(2) + "KB"; //kb
  if (size < Math.pow(num, 3))
    return (size / Math.pow(num, 2)).toFixed(2) + "MB"; //M
  if (size < Math.pow(num, 4))
    return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
  return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
}
// 格式必须 2022-11-21 17:14:12 输出格式 2022-11-21
const timeRest = (str) => {
  if (!str) return
  let result
  let caleDate = (str) => {
    let date = str.split(' ')
    if (date.length > 1) {
      let dayStr = new Date(date[0]).setHours(0, 0, 0, 0);
      let today = new Date().setHours(0, 0, 0, 0);
      let dateObj = {
          '-86400000': '昨天',
          0: '今天'
      }
      let timeText = (date[1].split(':')).length > 2 ? date[1].slice(0, date[1].lastIndexOf(':')) : date[1] // 是否是 HH:MM:ss 格式
      if (!dateObj[dayStr - today] && new Date(dayStr).getFullYear() === new Date().getFullYear()) { // 今年
        return dayjs(date[0]).format('MM/DD') + ' ' + timeText
      } else if (!dateObj[dayStr - today]) { // 更早
        return dayjs(date[0]).format('YYYY/MM/DD')
      } else { // 今天、昨天
        return dateObj[dayStr - today] + ' ' + timeText
      }
    }
    return ''
  }
  switch (typeof str) {
    case 'string':
      result = caleDate(str)
      break
    case 'number':
      result = caleDate(dayjs(new Date(str)).format('YYYY/MM/DD HH:mm:ss'))
      break
    case 'object':
      result = caleDate(dayjs(str).format('YYYY/MM/DD HH:mm:ss'))
      break
  }
  return result
}
// 2018-02-5 => 2018/02/5
const resetTime = (time) => {
  if (!time || !(typeof time === 'string')) return ''
  return time.replace(/-/g, '/')
}
// 二进制颜色转rgba, #CCC => rgba
const hexToRgba = (hex, opacity) => {
  if (!hex) return ''
  return 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ',' + parseInt('0x' + hex.slice(5, 7)) + ',' + opacity + ')'
}
let timeWait = (time) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}
let getColor = (val, mini) => {
  if (mini) {
    return `image/color/img_${val}_mi.png`
  } else {
    return `image/color/img_${val}.png`
  }
}

// 附件拆分，名称与后缀
let fileSuffix = (fileName) => {
  if (!fileName) return
  let idx = fileName.lastIndexOf('.')
  let str = fileName.slice(0, idx)
  let flt = fileName.slice(idx)
  return `<a>${str}</a><a>${flt}</a>`
}
/**
 *
 * @param {Array} tree // 遍历数据
 * @param {Number | String} id // 查询下标
 * @param {String} children // 子节点属性, 默认children
 * @returns
 */
const findNodeById = (tree, id, children = 'children') => {
  for (const node of tree) {
    if (Number(node.id) === id) return node
    if (node[children] && node[children]. length > 0) {
      const foundNode = findNodeById(node[children], id)
      if(foundNode) return foundNode
    }
  }
  return null
}

Vue.prototype.fileDown = fileDown
Vue.prototype.isCanPreview = isCanPreview
Vue.prototype.getOssUrl = getOssUrl
Vue.prototype.opendImgUrl = opendImgUrl
Vue.prototype.getBase64Img = getBase64Img
Vue.prototype.uuid = uuid
Vue.prototype.getFileTypeUrl = getFileTypeUrl
Vue.prototype.canPreview = canPreview
Vue.prototype.$$ = optionalChaining
Vue.prototype.getfilesize = getfilesize
Vue.prototype.timeRest = timeRest
Vue.prototype.resetTime = resetTime
Vue.prototype.hexToRgba = hexToRgba
Vue.prototype.timeWait = timeWait
Vue.prototype.fileSuffix = fileSuffix
Vue.prototype.getColor = getColor
Vue.prototype.findNodeById = findNodeById
